import React, { useState, useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import axios from 'axios';
import { API_BASE_URL } from '../utils';
import { Reveal } from './motion';
import { SectionHead } from './components';
import { BG_SOFT, BORDER, TXT, TXT_DIM, card } from './theme';

/** Admin-managed testimonials / trust logos. Renders nothing until there's at
 *  least one published item, so the marketing page is unaffected when empty. */
export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let active = true;
    axios.get(`${API_BASE_URL}/api/testimonials`)
      .then((res) => { if (active && Array.isArray(res.data?.testimonials)) setItems(res.data.testimonials); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  if (!items.length) return null;
  const quotes = items.filter((t) => t.quote);
  const logos = items.filter((t) => !t.quote && t.logo_url);

  return (
    <Box sx={{ bgcolor: BG_SOFT, borderTop: `1px solid ${BORDER}`, borderBottom: `1px solid ${BORDER}` }}>
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 9 } }}>
        <Reveal><SectionHead overline="Trusted by teams" title="What our customers say" /></Reveal>
        {quotes.length > 0 && (
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: quotes.length > 1 ? 'repeat(2,1fr)' : '1fr' }, gap: 2.5, mb: logos.length ? 5 : 0 }}>
            {quotes.map((t, i) => (
              <Reveal key={t.id} delay={i * 60}>
                <Box sx={{ ...card, p: { xs: 3, md: 3.5 }, height: '100%' }}>
                  <FormatQuoteIcon sx={{ color: 'rgba(255,102,0,0.5)', fontSize: 34, mb: 1 }} />
                  <Typography sx={{ color: TXT, fontSize: '1.02rem', lineHeight: 1.7, mb: 2 }}>“{t.quote}”</Typography>
                  <Typography sx={{ fontWeight: 700, color: TXT, fontSize: '0.92rem' }}>
                    {t.author}{t.company ? <Box component="span" sx={{ color: TXT_DIM, fontWeight: 500 }}>{`, ${t.company}`}</Box> : null}
                  </Typography>
                </Box>
              </Reveal>
            ))}
          </Box>
        )}
        {logos.length > 0 && (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: { xs: 4, md: 6 } }}>
            {logos.map((t) => (
              <Box key={t.id} component="img" src={t.logo_url} alt={t.company || 'logo'}
                sx={{ height: { xs: 26, md: 34 }, objectFit: 'contain', opacity: 0.75, filter: 'grayscale(1)', transition: 'opacity .2s, filter .2s', '&:hover': { opacity: 1, filter: 'none' } }} />
            ))}
          </Box>
        )}
      </Container>
    </Box>
  );
}
